export default "__VITE_ASSET__z8dun9CQ__"